import { gColors } from '~/modules/gColors/colors';
import { colorLibrary } from './colorLibrary';

export const colorHelper = {
  getTheme() {
    const isDarkMode = $('html.theme-dark').length;
    return isDarkMode! ? colorLibrary['dark'] : colorLibrary['light'];
  },
  hexToDec(icon) {
    return parseInt(icon, 16);
  },
  getIcon(icon) {
    let iconSet = {
      'section': this.hexToDec('F054'),
      'license': this.hexToDec('F069'),
      'certificate': this.hexToDec('F070'),
      'form-stack': this.hexToDec('F039'),
      'approval': this.hexToDec('F019'),
      'payment': this.hexToDec('f301'),
      'form': this.hexToDec('f300'),
      'dynamic-image': this.hexToDec('F181'),
      'mapping': this.hexToDec('F214'),
      'process-flow': this.hexToDec('0f011'),
      'notification-on': this.hexToDec('f302'),
      'build': this.hexToDec('f078'),
      'status': this.hexToDec('f140'),
      'picklist': this.hexToDec('f190'),
      'refresh': this.hexToDec('F025'),
      'set-data': this.hexToDec('0f027'),
      'save-data': this.hexToDec('0f026'),
      'find-data': this.hexToDec('0f028'),
      'export-file': this.hexToDec('0e901'),
      'wastebasket': this.hexToDec('1F5D1'),
      'find-count': this.hexToDec('0e902'),
      'api': this.hexToDec('F006'),
      'actions': this.hexToDec('0f184'),
      'bell': this.hexToDec('0f005'),
      'form-approve': this.hexToDec('0f036'),
      'monitor': this.hexToDec('0f036'),
      'model': this.hexToDec('02610'),
      'object-model': this.hexToDec('02610'),
    };
    return iconSet[icon];
  },
  getIconColor(icon) {
    let colorIconSet = {
      'section': gColors('Rust').hex,
      'license': gColors('Blue Violet').hex,
      'certificate': gColors('Alizarin').hex,
      'form-stack': gColors('Denim').hex,
      'approval': gColors('Laurel').hex,
      'payment': gColors('Purple Heart').hex,
      'form': gColors('Denim').hex,
      'mapping': gColors('Blush').hex,
      'process-flow': gColors('Rust').hex,
    };

    return colorIconSet[icon];
  }
};